import module from 'recursoshumanos/module.js'
import template from './template.html'

const diacriticosRegex = /[\u0300-\u036f]/g
const normalizar = (valor) => valor.normalize('NFD').replace(diacriticosRegex, '').toUpperCase()

export class RecursoshumanosVisorlotesListaComponent {
  idEmpresa
  clase
  registroPatronalId
  proyectos
  fecha
  data
  filtro = ''

  constructor (RecursoshumanosVisorlotesService) {
    this.RecursoshumanosVisorlotesService = RecursoshumanosVisorlotesService
  }

  filtrar () {
    let filtro = normalizar(this.filtro)
    this.resultados = this.data.filter((item) => item.busqueda.indexOf(filtro) >= 0)
  }

  $onChanges (changes) {
    console.log(this.registroPatronalId, 'lista')
    if (changes.data) {
      this.data.forEach((item) => (item.busqueda = `${normalizar(item.nombres)}|${item.numero_lote}`))
      this.resultados = [...this.data]
    }
  }

  eliminarLote(item) {
    this.data = this.data.filter(i => i.numero_lote !== item.numero_lote)
    this.filtrar()
  }

  exportarExcel () {

    let config = {
      idEmpresa: this.idEmpresa,
      clase: this.clase,
      registroPatronalId: this.registroPatronalId,
      proyectos: this.proyectos,
      tipoMovimientoId: 0,
      fecha: this.fecha
    }
    return this.RecursoshumanosVisorlotesService.exportarMasivoExcel(config)
  }

  exportarSUA () {
    this.exportandoSua = true
  }
}

module.component('recursoshumanosVisorlotesLista', {
  controller: RecursoshumanosVisorlotesListaComponent,
  template,
  bindings: {
    idEmpresa: '<',
    clase: '<',
    registroPatronalId: '<',
    proyectos: '<',
    fecha: '<',
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/visorlotes/lista/component.js